export default __webpack_public_path__ + "fb6f3c230cb846e25247dfaa1da94d8f.gif";